export default __webpack_public_path__ + "static/media/pro-elevate-blk-banner-3.5a4d0ca1.jpg";